import Section from './_Section'
import { useState, useEffect } from 'react'
import { createMarkup } from '../../helpers/markup'
import ButtonEl from '../helpers/ctas/Button'
import { detectShadeClash, transformPaddingToTailwind } from '../../helpers/style'
import { CheckIcon } from '@heroicons/react/24/solid'
import TitleBlock from '../helpers/TitleBlock'
import RatesCalloutBlock from '../helpers/RatesCalloutBlock'

const ProductFiftyFiftyContent = (props) => {
  const [highlightColor, setHighlightColor] = useState('secondary')
  useEffect(() => {
    setHighlightColor((prevState) => {
      if (detectShadeClash(props.backgroundColor, prevState)) {
        return 'primary'
      }
      return prevState
    })
  }, [])
  const componentPadding = transformPaddingToTailwind(props.componentPadding, true)

  return (
    <Section type="product5050" innerClass={`max-w-none ${componentPadding.top}`} sectionTitle={false} {...props}>
      {(props.title || props.description) && (
        <div class={`container mx-auto ${componentPadding.mid} `}>
          <TitleBlock headingClass={`w-full `} {...props} />
        </div>
      )}
      <div
        className={`${componentPadding.card} ${componentPadding.bottom} grid lg:grid-cols-2 grid-flow-row-dense grid-flow-col grid-rows-[repeat(10,_auto)] lg:max-w-[90%] xl:max-w-[75%] 2xl:max-w-[60%] mx-auto  justify-center before:block before:absolute before:bottom-[-1px] before:left-0 before:w-[100vw] content-[''] before:h-[25%] before:z-[-1] before:bg-white`}
      >
        {props.contentBlockItems.map((item, i) => {
          const col = i + 1
          return (
            <div className="grid border-2 bg-white text-light text-shadow-off rounded-3xl max-w-[65ch] shadow-2xl grid-rows-subgrid row-span-5 mx-8 p-8 mb-6 mt-0 ">
              {item.title && <div className={`font-bold text-lg text-center`}>{item.title}</div>}

              {item.description && (
                <div
                  className={`text-sm mt-2`}
                  data-rte="true"
                  dangerouslySetInnerHTML={createMarkup(item.description)}
                ></div>
              )}

              {item.ctaLink?.length > 0 && (
                <>
                  <ButtonEl
                    link={item.ctaLink[0]?.link}
                    theme={item.ctaLink[0]?.linkType.toLowerCase()}
                    className="!justify-center mt-6"
                  />
                </>
              )}

              {item.product?.variants?.length > 0 && (
                <div
                  className={`${item.ctaLink?.length > 0 || (item.description && item.ctaLink?.length < 1) ? 'mt-8' : ''}`}
                >
                  <RatesCalloutBlock rate={item.product} idx={0} />
                </div>
              )}
            </div>
          )
        })}
      </div>
    </Section>
  )
}

export default ProductFiftyFiftyContent
